export const OAuthErrorList = [
  'connector.insufficient-permissions',
  'oauth.access-denied',
  'oauth.authorization-error-retryable',
  'oauth.authorization-error-unretryable',
] as const;
export type OAuthError = (typeof OAuthErrorList)[number];

export const oauthErrorTranslationMapping: Record<OAuthError, string> = {
  'connector.insufficient-permissions': 'errorInsufficientPermissions',
  'oauth.access-denied': 'errorAccessDenied',
  'oauth.authorization-error-retryable': 'errorDefault',
  'oauth.authorization-error-unretryable': 'errorDefault',
};
